/* eslint-disable import/no-anonymous-default-export */
import { NexiDigitalAPI } from "./NexiDigitalAPI";

const createFeedzIntegration = () => {
  return NexiDigitalAPI({
    method: "POST",
    url: "/integration/",
    data: { integrationType: "FEEDZ" },
  });
};

const getFeedzIntegration = () => {
  return NexiDigitalAPI({
    method: "GET",
    url: "/integration/",
    params: { integrationType: "FEEDZ" },
  });
};

const validateFeedzToken = (token: string) => {
  return NexiDigitalAPI({
    method: "POST",
    url: "/integration/feedz/validate-token",
    data: { token },
  });
};

const activateIntegration = (idIntegration: number) => {
  return NexiDigitalAPI({
    method: "PUT",
    url: `/integration/${idIntegration}/activate`,
  });
};

const deactivateIntegration = (idIntegration: number) => {
  return NexiDigitalAPI({
    method: "PUT",
    url: `/integration/${idIntegration}/deactivate`,
  });
};

export default {
  validateFeedzToken,
  getFeedzIntegration,
  activateIntegration,
  deactivateIntegration,
  createFeedzIntegration,
};
